import { Button } from "@/components/ui";
import { useWebsites } from "@/lib/api";
import { PagesPanel } from "@/screens/KnowledgeScreen";
import { useCompleteStep } from "./useCompleteStep";

export function PagesStep() {
  const websites = useWebsites();
  const complete = useCompleteStep();
  const sites = websites.data ?? [];
  const stillDiscovering = sites.some(
    (w) => w.sitemapStatus === "pending" || w.sitemapStatus === "discovering",
  );
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-[24px] font-bold tracking-[-0.02em]">
          Which pages should it read?
        </h1>
        <p className="mt-1 text-[14px] text-muted">
          These are the pages we found. Untick anything that should not shape
          the answers — legal pages, old news, a careers board.
        </p>
      </div>
      {sites.map((w) => (
        <PagesPanel key={w.id} website={w} />
      ))}
      <div className="flex items-center justify-between">
        <p className="text-[13px] text-muted">
          {stillDiscovering
            ? "Still looking for pages on some sites…"
            : "Finishing reads every ticked page. It takes a few minutes."}
        </p>
        <Button
          variant="primary"
          disabled={complete.isPending}
          onClick={() => complete.mutate("pages")}
        >
          {complete.isPending ? "Finishing…" : "Finish setup"}
        </Button>
      </div>
    </div>
  );
}
